module.exports = __webpack_public_path__ + "static/plain-medium-8bff3314fc2853137e0bdb6cf416902d.woff2";